var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "63e992242d65538d958580f1_62e33ff5be01f764179d4f2f_Arrow%2520Right.svg.svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2219 12.2089L14.1244 8.11139L15.2046 7.03125L21.1461 12.9728L15.2046 18.9143L14.1244 17.8342L18.2219 13.7367H3.98835V12.2089H18.2219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2219 12.2089L14.1244 8.11139L15.2046 7.03125L21.1461 12.9728L15.2046 18.9143L14.1244 17.8342L18.2219 13.7367H3.98835V12.2089H18.2219Z",
    fill: "url(#paint0_linear_324_25)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_25",
    x1: 20.6166,
    y1: 27.4837,
    x2: 0.248521,
    y2: 24.2501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRightArrow);
export default __webpack_public_path__ + "static/media/orange-right-arrow.9a194b61e0bd1c128751405e0fac125a.svg";
export { ForwardRef as ReactComponent };